export class SetRegisterData {
    static readonly type = '[Register] Set data';

    constructor(public payload: any) {
    }
}
